import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

/**
 * Estados da tela (v2.1, p.32). Toda lista nasce com cinco estados desenhados
 * — carregando, vazia, sem resultado, com erro e sem permissao — e nenhum deles
 * e uma tela em branco. Este componente desenha os quatro que tem texto; o
 * carregando e o esqueleto da propria lista.
 *
 * O texto nunca e "Nenhum registro encontrado". Ou ele diz o que filtrar
 * diferente, ou ele diz o que cadastrar para comecar — e sempre oferece a saida
 * como acao, nao como conselho. O bloco do icone leva o tom do estado (p.32):
 * marca para a lista vazia, neutro para o sem resultado, erro para o que nao
 * carregou e atencao para o sem permissao.
 */
export type TomDoEstado = 'marca' | 'neutro' | 'erro' | 'atencao';

const TOM: Record<TomDoEstado, { readonly bloco: string; readonly icone: string }> = {
  marca: { bloco: 'bg-marca-forte', icone: 'text-marca' },
  neutro: { bloco: 'bg-tela', icone: 'text-tinta-secundaria' },
  erro: { bloco: 'bg-erro-fundo', icone: 'text-erro' },
  atencao: { bloco: 'bg-atencao-fundo', icone: 'text-atencao' },
};

export function EstadoVazio({
  titulo,
  descricao,
  acao,
  icone: Icone,
  tom = 'neutro',
}: {
  readonly titulo: string;
  readonly descricao: string;
  readonly acao?: ReactNode;
  /** O icone do vocabulario (p.19) que diz de que estado se trata. */
  readonly icone?: LucideIcon;
  readonly tom?: TomDoEstado;
}) {
  return (
    <div className="flex flex-col items-center gap-2 px-6 py-12 text-center">
      {Icone ? (
        <span className={`mb-2 flex size-12 items-center justify-center rounded-controle ${TOM[tom].bloco}`}>
          <Icone aria-hidden="true" className={`size-[var(--icone-destaque)] ${TOM[tom].icone}`} />
        </span>
      ) : null}
      <p className="txt-subtitulo text-tinta">{titulo}</p>
      <p className="txt-apoio max-w-[var(--texto-max)] text-pretty text-tinta-secundaria">{descricao}</p>
      {acao ? <div className="mt-2 flex flex-wrap items-center justify-center gap-2">{acao}</div> : null}
    </div>
  );
}
